import { __assign } from 'tslib';
import MuiDialogTitle from '@mui/material/DialogTitle';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React from 'react';

var ContentWrapper = styled('div')({
    display: 'flex',
    alignItems: 'flex-start',
});
var Title = styled(Typography)({
    flex: 'auto',
});
var EndAdornmentHeightWrapper = styled('div')(function (_a) {
    var theme = _a.theme;
    return (__assign(__assign({}, theme.typography.h3), { display: 'flex', alignItems: 'center', '&::after': {
            width: 0,
            content: '"\\00a0"',
        } }));
});
var EndAdornmentAlignWrapper = styled('div')({
    display: 'flex',
    alignItems: 'center',
    height: 0,
});
var DialogTitle = React.forwardRef(function DialogTitle(_a, ref) {
    var children = _a.children, endAdornment = _a.endAdornment;
    return (React.createElement(MuiDialogTitle, { ref: ref },
        React.createElement(ContentWrapper, null,
            React.createElement(Title, { variant: "h3", component: "span" }, children),
            endAdornment && (React.createElement(EndAdornmentHeightWrapper, null,
                React.createElement(EndAdornmentAlignWrapper, null, endAdornment))))));
});

export { DialogTitle as default };
